import { useSearchParams } from "react-router-dom";
import { getReleases } from "../data";
import '../App.css';

export default function InfoPage() {

    const [searchParams,] = useSearchParams();
    const target = searchParams.get("target")
    const releases = getReleases()
    let name = ""
    let status = ""
    let author = ""
    let updated = ""

    console.log(target)

    if (target) {
        for (const group of releases) {
            for (const release of group.items) {
                if (release.index === target) {
                    name = release.name
                    status = release.status
                    author = release.author
                    updated = release.updated
                    break
                }
            }
        }
    }

    document.title = name + " (Info)"

    return (
        <div>
            <div className="centerText">
                Name: {name}
                <br></br>
                Status: {status}
                <br></br>
                Author: {author}
                <br></br>
                Updated: {updated}
            </div>
        </div>
    );
}